

import deepCopy from "../../utilities/deepCopy";
import {denormalizeFilters} from "./normalizeFilters";

export const unselectAllFilters = (filters, containerIndex) => {
  filters[containerIndex].filters.map(filter => {
    filter.selected = false;
    return filter;
  })
};

const checkAllFiltersUnselected = filters => filters.every(f => !f.selected);

export const toggleFilter = (filters, containerIndex, filterIndex, all) => {
  const filter = filters[containerIndex].filters[filterIndex];
  const allFilter = filters[containerIndex].filters[0];
  if (all) {
    if (!filter.selected) {
      unselectAllFilters(filters, containerIndex);
      filter.selected = true;
    }
  } else {
    allFilter.selected = false;
    filter.selected = !filter.selected;
  }
  const allFiltersUnselected = checkAllFiltersUnselected(filters[containerIndex].filters);
  if (allFiltersUnselected) {
    allFilter.selected = true;
  }
};

export const prepareFiltersToSend = filters => {
  let result = deepCopy(filters);

  result.forEach(f => {
    f.filters = f.filters.filter(filter => filter.selected);
  });

  result = result
    .filter(f => !f.filters.some(filter => filter.value === "All"))
    .filter(f => f.filters.length !== f.numberOfFilters);

  result = denormalizeFilters(result);

  return result;
};


export const sortFilters = filters => {
  filters.forEach(filter => {
    filter.filters = filter.filters.sort((a, b) => {
      if(a.value < b.value) return -1;
      if(a.value > b.value) return 1;
      return 0;
    })
  })
};

export const toggleIsScore = ({ filters, filterIndex}) => {
  let isScoreIndex;
  filters.forEach((filter, i) => {
    filter.isScore ? isScoreIndex = i : null;
  });
  const filter = filters[filterIndex];
  if (isScoreIndex === undefined) {
    filter.isScore = true;
    return;
  }
  if (isScoreIndex === filterIndex) {
    filter.isScore = !filter.isScore;
    return;
  }
  if (isScoreIndex !== filterIndex) {
    filters[isScoreIndex].isScore = false;
    filter.isScore = true;
  }
};








// WEBPACK FOOTER //
// ./src/modules/filters/functions.js